// Non-component helpers for the structured rule editor fields — split out of
// QARuleEditor.tsx (which exports only components + string constants) so
// react-refresh's only-export-components rule doesn't flag these functions.
import { type QARule } from "@pages/QASettings/baseQaTypes";
import { type ReportType, type RuleBodyFields, parseRuleBody } from "@pages/QASettings/qaRuleBlob";

export const REPORT_TYPES: ReportType[] = ["IA", "RA"];

// Toggle `t` in `current`, enforcing at least one selected type. Returns the
// same array reference when the toggle would drop the last remaining type,
// so callers can cheaply detect a no-op.
export const toggleReportType = (current: ReportType[], t: ReportType): ReportType[] => {
  const has = current.includes(t);
  if (has && current.length === 1) return current;
  return REPORT_TYPES.filter((x) => (x === t ? !has : current.includes(x)));
};

// A rule's structured fields, i.e. the REST `rule` (name) field plus the
// parsed/edited `instructions` blob fields.
export type EditableRuleFields = { rule: string } & RuleBodyFields;

export const deriveFields = (rule: QARule): EditableRuleFields => ({
  rule: rule.rule,
  ...parseRuleBody(rule.instructions),
});
